"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var defaultProps = {
  componentName: "basicBanner",
  cms: {
    style: {
      bottomSpace: "Title bottom space",
      containerWidth: "Container size"
    },
    links: {
      linkTitle: "Link title",
      linkUrl: "Link url"
    },
    content: {
      title: "Title",
      content: "Content",
      linkTitle: "Link title"
      // linkUrl: "Link url ",
    },
    media: {
      imgUrl: "Image url",
      alt: "Atl text *"
    }
  },

  styleType: {
    style: {
      bottomSpace: { type: "textField" },
      containerWidth: { type: "textField" }
    }
  },
  props: _defineProperty({
    style: {
      bottomSpace: "15",
      containerWidth: "700"
    },
    links: {
      linkTitle: "learn more",
      linkUrl: ""
    },
    content: {
      title: "<span>Limits Exist Only in the Mind</span>",
      content: "<span>Lorem Ipsum is simply dummy text of the printing and typesetting industry.Lorem Ipsum has been the industry's standard dummy text\n      ever since the 1500s, when an unknown printer took a galley Lorem\n      Ipsum is simply dummy text of the printing and typesetting\n      industry.Lorem Ipsum has been the industry's standard dummy text\n      ever since the 1500s, when an unknown printer took a galley</span>\n      "
    },
    media: {
      background: "https://ik.imagekit.io/marketcube/platform/storybook/dd.jpg"
    }
  }, "media", {
    background: "https://ik.imagekit.io/marketcube/platform/storybook/dd.jpg"
  })
};
exports.default = defaultProps;